
/*
|--------------------------------------------------------------------------
| Routes
|--------------------------------------------------------------------------
|
| This contains the application routes, used in the main nav sidebar.
| If a route does not need to be in the sidebar then it does not go in
| this file. Also if the route is the same for all users then it does not need
| to go in this file.
|
*/

import Permissions from "@/config/Permissions.js";

// Define the application routes;
const routes = [
    {
        name: 'Home',
        // @TODO Added for stability. This will need to be updated
        permissions: [
            Permissions.ORDER_CREATE
        ],
        url: '/',
        icon: 'home'
    },
    {
        name: 'Dashboard',
        // @TODO Added for stability. This will need to be updated
        //permissions: '[PLACEHOLDER]',
        url: '/dashboard',
        icon: 'dashboard'
    },
    {
        name: 'Export Blueprints',
        permissions: [
            Permissions.EXPORT_BLUEPRINT
        ],
        url: '/admin/export-blueprints',
        icon: 'exports'
    },
    {
        name: 'Exports',
        permissions: [
            Permissions.EXPORTS
        ],
        url: '/admin/exports',
        icon: 'exports'
    },
    {
        name: 'Import Blueprints',
        permissions: [
            Permissions.IMPORT_BLUEPRINT
        ],
        url: '/admin/import-blueprints',
        icon: 'imports'
    },
    {
        name: 'Imports',
        permissions: [
            Permissions.IMPORT
        ],
        url: '/admin/imports',
        icon: 'imports'
    },
    {
        name: 'Formulary Viewer',
        // permissions: [
        //     Permissions.USER_FORMULARY_VIEWER // No longer needed because this is for all users now
        // ],
        url: '/formulary-classification-viewer',
        icon: 'formulary-viewer'
    },
    {
        name: 'Reporting',
        permissions: [
            Permissions.REPORTING_ALLOWED
        ],
        url: '/reporting',
        icon: 'reporting'
    },
    {
        name: 'Reporting licenses',
        permissions: [
            Permissions.REPORTING_LICENSES_VIEW_ANY
        ],
        url: '/admin/reporting-licenses',
        icon: 'reporting'
    },
    {
        name: 'News',
        permissions: [
            Permissions.CMS_CONTAINER_NEWS_CCG_VIEW,
            Permissions.CMS_CONTAINER_CCG_VIEW
        ],
        url: '/news',
        icon: 'news'

    },
    {
        name: 'Education',
        permissions: [
            Permissions.CMS_CONTAINER_EDUCATION_CCG_VIEW,
            Permissions.CMS_CONTAINER_CCG_VIEW
        ],
        url: '/education',
        icon: 'education'
    },
    {
        name: 'Orders',
        permissions: [
            Permissions.ORDER_ASSIGNED_VIEW_ALL
        ],
        url: '/orders',
        icon:'orders'
    },
    {
        name: 'Supplier Suborders',
        permissions: [
            Permissions.SUPPLIER_SUBORDER,
            Permissions.SUPPLIER_SUBORDER_VIEW_ALL
        ],
        url: '/admin/supplier-suborders',
        icon:'orders'
    },
    {
        name: 'Supplier Invoices',
        permissions: [
            Permissions.SUPPLIER_INVOICING,
            Permissions.SUPPLIER_INVOICING_VIEW_ALL
        ],
        url: '/admin/supplier-invoices',
        icon:'file'
    },
    {
        name: 'Supplier Sent Suborders',
        permissions: [
            Permissions.SUPPLIER_SENT_SUBORDER,
            Permissions.SUPPLIER_SENT_SUBORDER_VIEW_ALL
        ],
        url: '/admin/supplier-sent-suborders',
        icon:'file'
    },
    {
        name: 'Finance Live Suborders',
        permissions: [
            Permissions.FINANCE_LIVE_SUBORDER,
            Permissions.FINANCE_LIVE_SUBORDER_VIEW_ALL
        ],
        url: '/admin/finance/live-orders',
        icon:'file'
    },
    {
        name: 'Finance Invoices',
        permissions: [
            Permissions.FINANCE_INVOICING,
            Permissions.FINANCE_INVOICING_VIEW_ALL
        ],
        url: '/admin/finance/invoices',
        icon:'file'
    },
    {
        name: 'Manage News',
        //permissions:resourcePermissions.cms_container.news.manage,
        permissions: [
            Permissions.CMS_CONTAINER_NEWS_CCG_MANAGE
        ],
        url: '/admin/cms/news',
        isAdmin:true,
        icon: 'news'
    },
    {
        name: 'Manage Education',
        //permissions:resourcePermissions.cms_container.education.manage,
        permissions: [
            Permissions.CMS_CONTAINER_EDUCATION_CCG_MANAGE
        ],
        url: '/admin/cms/education',
        isAdmin:true,
        icon: 'education'
    },
    {
        name: 'Manage Pages',
        //permissions:resourcePermissions.cms_container.page.manage,
        permissions: [
            Permissions.CMS_CONTAINER_PAGE_CCG_MANAGE
        ],
        url: '/admin/cms/page',
        isAdmin:true,
        icon: 'pages'
    },

    // Admin Routes
    {
        name: 'View Orders',
        //permissions:resourcePermissions.order.view.all,
        permissions: [
            Permissions.ORDER_BYPASS,
            Permissions.ORDER_VIEW_ALL
        ],
        url: '/admin/orders',
        isAdmin:true,
        icon: 'orders'
    },
    // {
    //     name: i18n.t('global.routes.admin.orderEdits.name'),
    //     permissions:resourcePermissions.orderEdits.view.all,
    //     url: i18n.t('global.routes.admin.orderEdits.url'),
    //     isAdmin:true
    // },
    {
        name: 'Manage Held Orders',
        //permissions:resourcePermissions.order.held.view.all,
        permissions: [
            Permissions.HELD_ORDER_BYPASS,
            Permissions.HELD_ORDER_VIEW_ALL,
            Permissions.ORDER_PROCESS_ORDER_AUTHORISATIONS_VIEW
        ],
        url: '/admin/held-orders',
        isAdmin:true,
        icon: 'file-edit'
    },
    {
        name: 'Manage Suppliers',
        //permissions:resourcePermissions.supplier.view.all,
        permissions: [
            Permissions.SUPPLIER_BYPASS,
            Permissions.SUPPLIER_VIEW_ALL
        ],
        url: '/admin/suppliers',
        isAdmin:true,
        icon: 'truck'
    },
    {
        name: 'Manage Supply Routes',
        //permissions:resourcePermissions.supplier.view.all,
        permissions: [
            Permissions.SUPPLY_ROUTE_BYPASS,
            Permissions.SUPPLY_ROUTE_VIEW_ALL
        ],
        url: '/admin/supply-routes',
        isAdmin:true,
        icon: 'truck'
    },
    {
        name: 'Manage Depots',
        //permissions:resourcePermissions.nhs_supply_chain_depot.view.all,
        permissions: [
            Permissions.NHS_SUPPLY_CHAIN_DEPOT_BYPASS,
            Permissions.NHS_SUPPLY_CHAIN_DEPOT_VIEW_ALL
        ],
        url: '/admin/depots',
        isAdmin:true,
        icon: 'file'
    },
    {
        name: 'Manage CCGs',
        //permissions:resourcePermissions.ccg.view.all,
        permissions: [
            Permissions.CCG,
            Permissions.CCG_CRUD,
            Permissions.CCG_VIEW_ANY
        ],
        url: '/admin/ccgs',
        isAdmin:true,
        icon: 'ccgs'
    },
    {
        name: 'Manage Classifications',
        //permissions:resourcePermissions.formulary_classification.view.all,
        permissions: [
            Permissions.FORMULARY_CLASSIFICATION,
            Permissions.FORMULARY_CLASSIFICATION_CRUD,
            Permissions.FORMULARY_CLASSIFICATION_VIEW_ANY
        ],
        url: '/admin/formulary-classifications',
        isAdmin:true,
        icon: 'clipboard'
    },
    {
        name: 'Manage Formularies',
        //permissions:resourcePermissions.formulary_classification.view.all,
        permissions: [
            Permissions.FORMULARY,
            Permissions.FORMULARY_CRUD,
            Permissions.FORMULARY_VIEW_ANY
        ],
        url: '/admin/formularies',
        isAdmin:true,
        icon: 'clipboard'
    },
    {
        name: 'Manage Locations',
        //permissions:resourcePermissions.location.view.all,
        permissions: [
            Permissions.LOCATION,
            Permissions.LOCATION_CRUD,
            Permissions.LOCATION_VIEW_ANY
        ],
        url: '/admin/locations',
        isAdmin:true,
        icon: 'pin'
    },
    {
        name: 'Stocktakes',
        permissions: [
            Permissions.STOCKTAKE_VIEW_ALL,
        ],
        url: '/admin/stocktakes',
        icon: 'clipboard'
    },
    {
        name: 'Manage Products',
        //permissions:resourcePermissions.product.view.all,
        permissions: [
            Permissions.PRODUCT,
            Permissions.PRODUCT_CRUD,
            Permissions.PRODUCT_VIEW_ANY
        ],
        url: '/admin/products',
        isAdmin:true,
        icon: 'products'
    },
    {
        name: 'Barcodes',
        //permissions:resourcePermissions.product.view.all,
        permissions: [
            Permissions.ADMIN_BYPASS,
            Permissions.SYSTEM_ADMIN_OVERRIDE
        ],
        url: '/admin/barcodes',
        isAdmin:true,
        icon: 'barcode'
    },
    {
        name: 'Helpdesk Cases',
        permissions: [
            Permissions.HELPDESK_CASE_VIEW_ANY
        ],
        url: '/admin/helpdesk-cases',
        icon: 'mail'
    },
    {
        name: 'Channels',
        //permissions:resourcePermissions.channel.view.single,
        permissions: [
            Permissions.CHANNEL,
            Permissions.CHANNEL_CRUD,
            Permissions.CHANNEL_VIEW_ANY
        ],
        url: '/admin/channels',
        icon:'channels'
    },
    {
        name: 'Manage Channel',
        //permissions:resourcePermissions.channel.view.single,
        permissions: [
            Permissions.CHANNEL_VIEW_SINGLE,
            Permissions.CHANNEL_VIEW_ASSIGNED_SINGLE
        ],
        url: '/admin/channels/{channel.id}/edit',
        icon:'channels'
    },
    {
        name: 'Channel Orders',
        //permissions:resourcePermissions.channel.order.view.all,
        permissions: [
            Permissions.CHANNEL_ORDER_VIEW_ANY,
            Permissions.CHANNEL_ORDER_ASSIGNED_VIEW_ANY
        ],
        url: '/admin/channels/{channel.id}/orders',
        icon: 'orders'
    },
    {
        name: 'Channel Products',
        //permissions:resourcePermissions.channel.product.view.all,
        permissions: [
            Permissions.CHANNEL_PRODUCT_VIEW_ANY,
            Permissions.CHANNEL_PRODUCT_ASSIGNED_VIEW_ANY
        ],
        url: '/admin/channels/{channel.id}/products',
        icon: 'products'
    },
    {
        name: 'Channel Attr. Families',
        //permissions:resourcePermissions.channel.attributeFamily.view.all,
        permissions: [
            Permissions.CHANNEL_ATTRIBUTE_FAMILY_ATTRIBUTE_VIEW_ANY,
            Permissions.CHANNEL_ATTRIBUTE_FAMILY_ATTRIBUTE_ASSIGNED_VIEW_ANY
        ],
        url: '/admin/channels/{channel.id}/attribute-families',
        icon: 'layers'
    },
    {
        name: 'Channel CCGs',
        //permissions:resourcePermissions.channel.ccg.view.all,
        permissions: [
            Permissions.CHANNEL_CCG_VIEW_ANY,
            Permissions.CHANNEL_CCG_ASSIGNED_VIEW_ANY
        ],
        url: '/admin/channels/{channel.id}/ccgs',
        icon: 'ccgs'
    },
    {
        name: 'Channel Locations',
        //permissions:resourcePermissions.channel.location.view.all,
        permissions: [
            Permissions.CHANNEL_LOCATION_VIEW_ANY,
            Permissions.CHANNEL_LOCATION_ASSIGNED_VIEW_ANY
        ],
        url: '/admin/channels/{channel.id}/locations',
        icon: 'pin'
    },
    {
        name: 'Channel Formularies',
        //permissions:resourcePermissions.channel.formulary.view.all,
        permissions: [
            Permissions.CHANNEL_FORMULARY_VIEW_ANY,
            Permissions.CHANNEL_FORMULARY_ASSIGNED_VIEW_ANY
        ],
        url: '/admin/channels/{channel.id}/formularies',
        icon:'folder'
    },
    {
        name: 'Channel Classifications',
        //permissions:resourcePermissions.channel.formularyClassification.view.all,
        permissions: [
            Permissions.CHANNEL_FORMULARY_CLASSIFICATION_VIEW_ANY,
            Permissions.CHANNEL_FORMULARY_CLASSIFICATION_ASSIGNED_VIEW_ANY
        ],
        url: '/admin/channels/{channel.id}/formulary-classifications',
        icon: 'clipboard'
    },
    {
        name: 'Manage Users',
        //permissions:resourcePermissions.user.view.any,
        permissions: [
            Permissions.USER_BYPASS,
            Permissions.USER_VIEW_ALL
        ],
        url: '/admin/users',
        isAdmin:true,
        icon:'users'
    },
    {
        name: 'Manage Roles',
        //permissions:resourcePermissions.role.view.all,
        permissions: [
            Permissions.ROLE_BYPASS,
            Permissions.ROLE_VIEW_ALL
        ],
        url: '/admin/roles',
        isAdmin:true,
        icon:'users'
    },
    {
        name: 'View Marketing Opt-ins',
        //permissions:resourcePermissions.marketing_opt_in.view.all,
        permissions: [
            Permissions.MARKETING_OPT_IN_BYPASS,
            Permissions.MARKETING_OPT_IN_VIEW_ALL
        ],
        url: '/admin/marketing-opt-ins',
        isAdmin:true,
        icon:'message'
    },
    {
        name: 'Manage Files',
        //permissions:resourcePermissions.file.view.all,
        permissions: [
            Permissions.FILE_BYPASS,
            Permissions.FILE_VIEW_ALL
        ],
        url: '/admin/files',
        isAdmin:true,
        icon:'file'
    },
    {
        name: 'Options',
        permissions: [
            Permissions.OPTION_BYPASS,
            Permissions.OPTION_VIEW_ALL
        ],
        url: '/admin/options',
        isAdmin:true,
        icon:'settings'
    },
    {
        name: 'Attribute Families',
        permissions: [
            Permissions.ATTRIBUTE_FAMILY,
            Permissions.ATTRIBUTE_FAMILY_CRUD,
            Permissions.ATTRIBUTE_FAMILY_VIEW_ANY
        ],
        url: '/admin/attribute-families',
        isAdmin:true,
        icon:'layers'
    },
    {
        name: 'Taxonomies',
        permissions: [
            Permissions.TAXONOMY,
            Permissions.TAXONOMY_CRUD,
            Permissions.TAXONOMY_VIEW_ANY
        ],
        url: '/admin/taxonomies',
        isAdmin:true,
        icon:'list'
    },
    {
        name: 'Attributes',
        permissions: [
            Permissions.ATTRIBUTE,
            Permissions.ATTRIBUTE_CRUD,
            Permissions.ATTRIBUTE_VIEW_ANY
        ],
        url: '/admin/attributes',
        isAdmin:true,
        icon:'layers'
    },
    {
        name: 'System Events',
        permissions: [
            Permissions.ADMIN_BYPASS,
            Permissions.SYSTEM_ADMIN_OVERRIDE
        ],
        url: '/admin/system-events',
        isAdmin: true,
        icon: 'file-text'
    },
    {
        name: 'Database Restore',
        permissions: [
            Permissions.ADMIN_BYPASS,
            Permissions.SYSTEM_ADMIN_OVERRIDE
        ],
        url: '/admin/database-restore',
        isAdmin: true,
        icon: 'channels'
    },
    {
        name: 'Read Only Database',
        permissions: [
            Permissions.ADMIN_BYPASS,
            Permissions.SYSTEM_ADMIN_OVERRIDE
        ],
        url: '/admin/read-only-database',
        isAdmin: true,
        icon: 'channels'
    },
    {
        name: 'Forms',
        permissions: [
            Permissions.FORM,
            Permissions.FORM_CRUD,
            Permissions.FORM_VIEW_ANY
        ],
        url: '/admin/forms',
        isAdmin:true,
        icon:'list'
    },
    {
        name: 'View Error Logs',
        permissions: [
            Permissions.SYSTEM_ADMIN_OVERRIDE
        ],
        url: '/admin/logs',
        isAdmin:true,
        icon:'alert',
        iconColor: 'red'
    },
    {
        name: 'View Activity Logs',
        permissions: [
            Permissions.SYSTEM_ADMIN_OVERRIDE
        ],
        url: '/admin/activity-logs',
        isAdmin:true,
        icon:'user'
    },
];

routes.push({
    name: 'API Tester',
    permissions: [
        Permissions.SYSTEM_ADMIN_OVERRIDE
    ],
    url: '/apitesting',
    isAdmin:true,
    icon: 'terminal'
});
routes.push({
    name: 'Style Guide',
    permissions: [
        Permissions.SYSTEM_ADMIN_OVERRIDE
    ],
    url: '/styleguide',
    isAdmin:true,
    icon: 'columns'
});
routes.push({
    name: 'Testing',
    permissions: [
        Permissions.SYSTEM_ADMIN_OVERRIDE
    ],
    url: '/admin/testing',
    isAdmin:true,
    icon: 'user',
    iconColor: 'orange'
});


// Export the consts
export {routes};
